<template>
  <div class="form-page">
    <div class="image-upload">
      <p class="image-upload__tooltip" v-html="history[currentStep].field.tooltip"></p>
      <div class="image-upload__container">
        <img :src="value ? value : history[currentStep].field.img" class="image-upload__example" />
      </div>
      <span class="image-upload__filename" v-show="filename">✅ {{ filename }}</span>
      <input
        type="file"
        accept="image/*,.pdf"
        :id="`fileUploader-${field.name}`"
        hidden/>
      <label :for="`fileUploader-${field.name}`" class="image-upload__button">Escoger archivo</label>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
let uploader
let globalThis

export default {
  name: 'ImageUpload',
  data () {
    return {
      filename: '',
      value: ''
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      field: state => state.history[state.currentStep],
      config: state => state.config,
      isDev: state => state.isDev,
      leadId: state => state.additionalParams.lead_id || localStorage.getItem('leadId')
    })
  },
  mounted () {
    console.log('MOUNTED')
    if (this.history[this.currentStep].value) this.value = this.history[this.currentStep].value
    uploader = document.getElementById(`fileUploader-${this.field.name}`)
    uploader.addEventListener('change', this.uploadHandler)
    globalThis = this
  },
  beforeDestroy () {
    uploader.removeEventListener('change', this.uploadHandler)
  },
  methods: {
    uploadHandler: e => {
      console.log('CHANGE:', e)
      globalThis.filename = e.target.files[0].name
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        globalThis.value = reader.result
        globalThis.$store.commit('UPDATE_FIELD', { isValid: true, value: globalThis.value })
      })
      reader.readAsDataURL(e.target.files[0])
    }
  }
}
</script>

<style lang="scss" scoped>
.image-upload {
  margin: auto;
  &__tooltip {
    margin-bottom: 20px;
  }
  &_container {
    width: 100%;
  }
  &__example {
    width: 200px;
    margin: auto;
    border-radius: 10px;
  }
  &__filename {
    width: 100%;
    margin-top: 10px;
  }
  &__button {
    display: block;
    width: 200px;
    margin: 20px auto auto;
    padding: 0;
    line-height: 45px;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid gray;
    border-radius: 4px;
    background-color: transparent;
    color: grey;
    transition: .3s;
    box-shadow: 0 3px 12px rgba(0, 33, 108, .06);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/ImageUpload.vue